// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../../common/image.res.js");
var Utils$ReactHooksTemplate = require("../../common/utils.res.js");

function SurveyBuilderTypeSidebar(props) {
  var onSearchChange = props.onSearchChange;
  var searchQuery = props.searchQuery;
  var onAddQuestion = props.onAddQuestion;
  var pageItems = props.pageItems;
  var match = pageItems.length;
  return JsxRuntime.jsxs("aside", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("span", {
                              children: "Survey Pages"
                            }),
                        JsxRuntime.jsx("button", {
                              children: "+",
                              className: "sb-pages-add-btn",
                              title: "Add question",
                              type: "button",
                              onClick: (function (param) {
                                  Curry._1(onAddQuestion, undefined);
                                })
                            })
                      ],
                      className: "sb-pages-header sb-left-header flex items-center justify-between"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("img", {
                                    className: "sb-left-search-icon",
                                    src: Image$ReactHooksTemplate.search
                                  }),
                              JsxRuntime.jsx("input", {
                                    className: "sb-left-search-input",
                                    placeholder: "Search survey pages...",
                                    type: "text",
                                    value: searchQuery,
                                    onChange: (function ($$event) {
                                        Curry._1(onSearchChange, Utils$ReactHooksTemplate.formTargetValue($$event));
                                      })
                                  })
                            ],
                            className: "sb-left-search-field"
                          }),
                      className: "sb-left-search",
                      onClick: (function ($$event) {
                          $$event.stopPropagation();
                        })
                    }),
                JsxRuntime.jsx("div", {
                      children: match !== 0 ? Belt_Array.map(pageItems, (function (item) {
                                return JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("span", {
                                                    children: JsxRuntime.jsx("img", {
                                                          className: "sb-page-icon",
                                                          src: item.icon
                                                        }),
                                                    className: "sb-page-icon-wrap"
                                                  }),
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("span", {
                                                            children: item.label,
                                                            className: "sb-page-label"
                                                          }),
                                                      JsxRuntime.jsx("span", {
                                                            children: item.typeLabel,
                                                            className: "sb-page-type"
                                                          })
                                                    ],
                                                    className: "sb-page-content"
                                                  }),
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      item.actions.canAddBelow ? JsxRuntime.jsx("button", {
                                                              children: JsxRuntime.jsx("img", {
                                                                    className: "sb-page-action-icon",
                                                                    src: Image$ReactHooksTemplate.plusCircle
                                                                  }),
                                                              className: "sb-page-action",
                                                              title: "Add below",
                                                              type: "button",
                                                              onClick: (function (param) {
                                                                  Curry._1(item.actions.onAddBelow, undefined);
                                                                })
                                                            }) : null,
                                                      item.actions.canDuplicate ? JsxRuntime.jsx("button", {
                                                              children: JsxRuntime.jsx("img", {
                                                                    className: "sb-page-action-icon",
                                                                    src: Image$ReactHooksTemplate.copy
                                                                  }),
                                                              className: "sb-page-action",
                                                              title: "Duplicate",
                                                              type: "button",
                                                              onClick: (function (param) {
                                                                  Curry._1(item.actions.onDuplicate, undefined);
                                                                })
                                                            }) : null,
                                                      item.actions.canDelete ? JsxRuntime.jsx("button", {
                                                              children: JsxRuntime.jsx("img", {
                                                                    className: "sb-page-action-icon",
                                                                    src: Image$ReactHooksTemplate.trash
                                                                  }),
                                                              className: "sb-page-action",
                                                              title: "Delete",
                                                              type: "button",
                                                              onClick: (function (param) {
                                                                  Curry._1(item.actions.onDelete, undefined);
                                                                })
                                                            }) : null
                                                    ],
                                                    className: "sb-page-actions",
                                                    onClick: (function ($$event) {
                                                        $$event.stopPropagation();
                                                      })
                                                  })
                                            ],
                                            className: "sb-page-item " + (
                                              item.isActive ? "sb-page-item--active" : ""
                                            ),
                                            onClick: (function (param) {
                                                Curry._1(item.onClick, undefined);
                                              })
                                          }, item.id);
                              })) : JsxRuntime.jsx("div", {
                              children: searchQuery === "" ? "No survey pages yet. Click + to add a question." : "No questions match your search.",
                              className: "sb-pages-empty"
                            }),
                      className: "sb-pages-list"
                    })
              ],
              className: "sb-left"
            });
}

var make = SurveyBuilderTypeSidebar;

exports.make = make;
/* react/jsx-runtime Not a pure module */
